import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createEntitySliceSelectors } from '@aston/foundation';

import { IContactFormState } from './state';
import { FeatureName } from './feature';


export const selectState: MemoizedSelector<object, IContactFormState> = createFeatureSelector<IContactFormState>(FeatureName);

export const {
	selectEntity: selectForm,
	selectIsLoading: selectFormIsLoading,
	selectError: selectFormError
} = createEntitySliceSelectors(createSelector(selectState, state => state.form));

export const getIsOpened = (state: IContactFormState): boolean => state.isOpened;
export const selectIsOpened = createSelector(selectState, state => getIsOpened(state));
